import { MutationTree, Mutation } from 'vuex';
import { IFilter, IState } from './state';
import { ActionPayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
	state.query = payload
}

const toggleFilterMutation: MutationHandler<undefined> = (state, { payload }) => {
	state.showFilter = !state.showFilter
}

const setFilterMutation: MutationHandler<IFilter> = (state, { payload }) => {
	Object.assign(payload, {selected: !payload.selected})
}

const clearFiltersMutation: MutationHandler<undefined> = (state, { payload }) => {
	state.filters.forEach(filter => Object.assign(filter, {selected: false}));
	state.currentPage = 0
}

const paginateMutation: MutationHandler<number> = (state, { payload }) => {
	if(state.currentPage >= payload - 1) return
	state.currentPage += 1;
}

const setCurrentPageMutation: MutationHandler<number> = (state, { payload }) => {
	state.currentPage = payload;
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setQuery: setQueryMutation,
	toggleFilter: toggleFilterMutation,
	clearFilters: clearFiltersMutation,
	paginate: paginateMutation,
	setCurrentPage: setCurrentPageMutation,
	setFilter: setFilterMutation
}

export default mutations
